import React from "react";
import { Outlet } from "react-router-dom";
import SmoothScroll from "./SmoothScroll";
import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";
import { Toaster } from "../ui/sonner";

export default function SiteLayout() {
  return (
    <SmoothScroll>
      <div className="min-h-screen bg-[#050B14] text-white antialiased">
        <SiteHeader />
        <main>
          <Outlet />
        </main>
        <SiteFooter />
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: "#0F1A30",
              border: "1px solid #1E293B",
              color: "#F8FAFC",
            },
          }}
        />
      </div>
    </SmoothScroll>
  );
}
